
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { Card, CardContent } from '@/components/ui/card';

const LotteryEntryForm = () => {
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!agreedToTerms) {
      alert('Please agree to the Terms and Privacy Policy to continue.');
      return;
    }
    if (!formData.email.includes('@')) {
      alert('Please enter a valid email address.');
      return;
    }
    console.log('Form submitted:', formData);
    window.location.href = '/success';
  };

  return (
    <section id="entry-form" className="py-16 bg-gray-100">
      <div className="max-w-lg mx-auto px-4">
        <Card>
          <CardContent className="p-8">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-6">Join the Draw</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="fullName" className="block text-gray-700 font-medium mb-2">
                  Full Name *
                </label>
                <Input
                  id="fullName"
                  type="text"
                  required
                  value={formData.fullName}
                  onChange={(e) => setFormData({...formData, fullName: e.target.value})}
                  className="w-full"
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-gray-700 font-medium mb-2">
                  Email Address *
                </label>
                <Input
                  id="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="w-full"
                />
              </div>
              
              <div>
                <label htmlFor="phone" className="block text-gray-700 font-medium mb-2">
                  Phone Number (Optional)
                </label>
                <Input
                  id="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  className="w-full"
                />
              </div>
              
              <div className="flex items-start space-x-2">
                <Checkbox
                  id="agreement"
                  checked={agreedToTerms}
                  onCheckedChange={(checked) => setAgreedToTerms(checked === true)}
                  className="mt-1"
                />
                <label htmlFor="agreement" className="text-sm text-gray-700">
                  I agree to the{' '}
                  <a href="/terms" className="underline text-yellow-600">Terms and Conditions</a>
                  {' '}and{' '}
                  <a href="/privacy" className="underline text-yellow-600">Privacy Policy</a>
                </label>
              </div>
              
              <Button
                type="submit"
                disabled={!agreedToTerms}
                className="w-full bg-yellow-600 hover:bg-yellow-700 disabled:bg-gray-400 py-3"
              >
                Join the Draw
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default LotteryEntryForm;
